import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/styles/createStyles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    buttonsRow: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(4),

      '& > button + button': {
        marginLeft: theme.spacing(2),
      },
    },
  }),
);
